import type { Story } from '@/store/story-types'

export const PROXY_BUYING_STORY: Story = {
  id: 'proxy-buying',
  name: 'PROXY — Global Shopping Agent',
  narrative: 'An influencer proxy buying service connecting followers with overseas luxury, K-beauty, and Japanese goods through a request-estimate-payment-tracking flow.',
  goals: ['Browse proxy catalog', 'Submit proxy request', 'Review cost estimate', 'Pay and track order'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'home',
      description: 'Landing page with hero banner and proxy product catalog',
      blockRef: { category: 'k-commerce', blockId: 'hero-banner' },
    },
    {
      id: 'pg-request', title: 'Request', order: 1, status: 'draft', elementCount: 4, linkedPageId: 'request',
      description: 'Proxy purchase request form with cost estimate calculator',
      blockRef: { category: 'k-commerce', blockId: 'proxy-request-form' },
    },
    {
      id: 'pg-orders', title: 'Orders', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'orders',
      description: 'Order tracking page with status timeline and delivery updates',
      blockRef: { category: 'k-commerce', blockId: 'order-tracker' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart and checkout with payment processing',
      blockRef: { category: 'k-commerce', blockId: 'cart-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Proxy Catalog',
      description: 'Visitor browses available proxy products',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner and proxy product catalog with categories are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Submit Proxy Request',
      description: 'Visitor submits a proxy buying request with product details',
      steps: [
        { type: 'given', text: 'the visitor navigates to the request page', linkedPageId: 'request' },
        { type: 'when', text: 'they fill in the product URL, quantity, and preferences' },
        { type: 'then', text: 'a cost estimate with proxy fee, shipping, and total is displayed' },
        { type: 'and', text: 'the request form validates inputs before submission', linkedFlowId: 'validateProxyRequest' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Pay for Proxy Order',
      description: 'Visitor completes payment for the proxy purchase',
      steps: [
        { type: 'given', text: 'the visitor has a confirmed estimate' },
        { type: 'when', text: 'they proceed to cart and checkout', linkedPageId: 'cart' },
        { type: 'then', text: 'payment is processed and order confirmation is shown' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Track Order',
      description: 'Visitor tracks the status of their proxy order',
      steps: [
        { type: 'given', text: 'the visitor has a placed order' },
        { type: 'when', text: 'they navigate to the Orders page', linkedPageId: 'orders' },
        { type: 'then', text: 'a status timeline with purchase, shipping, and delivery steps is shown' },
      ],
    },
  ],
}
